import React, { useState } from "react";
import styles from "../HealthChat.module.css";

const StarIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#7C4DFF">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

const CalendarIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#5e35b1"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
    <path d="M9 16l2 2 4-4"></path>
  </svg>
);

export default function BookingPatientDetailsScreen({ onConfirm, onBack }) {
  const [formData, setFormData] = useState({
    fullName: "Riya Mehta",
    mobile: "+91 98765 43210",
    email: "riya.mehta@email.com",
    dob: "12 Jan 1995",
    isMyself: true,
  });

  return (
    <div className={styles.bookingWrapper}>
      {/* Header Actions */}
      <button className={styles.selectCareBack} onClick={onBack}>
        ← Back
      </button>
      {/* <div className={styles.headerRow}>
        
        <span className={styles.headerTitle}>Patient details</span>
        
      </div> */}

      {/* AI Message Bubble */}
      <div className={styles.messageBubbleRow}>
        <img
          src="/images/chatbotFemCare.svg"
          alt="Chatbot"
          width={52}
          height={52}
          className={styles.avatar}
        />
        <div className={styles.messageBubble}>
          Please confirm your details.
          <span className={styles.timeStamp}>10:32 AM</span>
        </div>
      </div>

      {/* Form Fields */}
      <div className={styles.patientForm}>
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>Full name</label>
          <input
            type="text"
            className={styles.textInput}
            value={formData.fullName}
            onChange={(e) =>
              setFormData({ ...formData, fullName: e.target.value })
            }
          />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>Mobile number</label>
          <input
            type="text"
            className={styles.textInput}
            value={formData.mobile}
            onChange={(e) =>
              setFormData({ ...formData, mobile: e.target.value })
            }
          />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>Email address</label>
          <input
            type="email"
            className={styles.textInput}
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>Date of birth</label>
          <div className={styles.inputWithIcon}>
            <input
              type="text"
              className={styles.textInput}
              value={formData.dob}
              readOnly
            />
            <CalendarIcon />
          </div>
        </div>

        {/* Checkbox Section */}
        <div className={styles.checkboxRow}>
          <input
            type="checkbox"
            id="myself"
            checked={formData.isMyself}
            onChange={(e) =>
              setFormData({ ...formData, isMyself: e.target.checked })
            }
            className={styles.customCheckbox}
          />
          <label htmlFor="myself" className={styles.checkboxLabel}>
            This is myself
          </label>
        </div>
      </div>

      {/* Submit Button */}
      <button
        className={styles.visitModelContinueBtn}
        onClick={onConfirm}
      >
        Continue to payment
      </button>
    </div>
  );
}
